import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { withRouter } from '../withRouter';
import ArticleCard from './ArticleCard';
import articlesService from '../../services/articles.service';
import styles from './ArticlesHub.module.scss';

class ArticlesHub extends Component {
    static displayName = ArticlesHub.name;

    constructor(props) {
        super(props);
        this.state = {
            allArticles: [],
            categories: [],
            selectedCategory: null,
            loading: true,
            error: null,
        };
    }

    componentDidMount() {
        this.loadCategories();
        this.loadAllArticles();
    }

    loadCategories = async () => {
        try {
            const categories = await articlesService.getCategories();
            this.setState({ categories });
        } catch (e) {
            console.warn('[ArticlesHub] Could not load categories:', e.message);
        }
    }

    loadAllArticles = async () => {
        this.setState({ loading: true, error: null });
        try {
            const result = await articlesService.getArticles({ pageSize: 100 });
            this.setState({
                allArticles: result.articles || [],
                loading: false,
            });
        } catch (e) {
            console.error('[ArticlesHub] Error loading articles:', e);
            this.setState({ error: 'Failed to load articles', loading: false });
        }
    }

    onCategoryChange = (categorySlug) => {
        this.setState({ selectedCategory: categorySlug });
    }

    render() {
        const { allArticles, categories, selectedCategory, loading } = this.state;

        // Client-side filter
        const filtered = selectedCategory
            ? allArticles.filter(a => a.categorySlug === selectedCategory)
            : allArticles;

        // Use first article as featured if no category filter
        let featuredArticle = null;
        let articles = filtered;
        if (!selectedCategory && filtered.length > 0) {
            featuredArticle = filtered[0];
            articles = filtered.slice(1);
        }

        return (
            <React.Fragment>
                <Helmet>
                    <title>Articles | Game City</title>
                    <meta name="description" content="Game night tips, party game guides, and the latest news from Game City." />
                </Helmet>
                <div className={styles.articlesHub}>
                    <div className={styles.cloudBG} />
                    <Container>
                        <h1 className={styles.pageTitle}>Articles</h1>

                        {featuredArticle && (
                            <div className={styles.heroCard} onClick={() => this.props.navigate(`/articles/${featuredArticle.slug}`)}>
                                {featuredArticle.featuredImageUrl && (
                                    <div className={styles.heroImage} style={{ backgroundImage: `url(${featuredArticle.featuredImageUrl})` }} />
                                )}
                                <div className={styles.heroContent}>
                                    {featuredArticle.categoryName && (
                                        <span className={styles.heroBadge}>{featuredArticle.categoryName}</span>
                                    )}
                                    <h2 className={styles.heroTitle}>{featuredArticle.title}</h2>
                                    {featuredArticle.excerpt && (
                                        <p className={styles.heroExcerpt}>{featuredArticle.excerpt}</p>
                                    )}
                                </div>
                            </div>
                        )}

                        {categories.length > 0 && (
                            <div className={styles.filters}>
                                <button
                                    className={`${styles.filterChip} ${!selectedCategory ? styles.active : ''}`}
                                    onClick={() => this.onCategoryChange(null)}
                                >
                                    All
                                </button>
                                {categories.map(cat => (
                                    <button
                                        key={cat.id}
                                        className={`${styles.filterChip} ${selectedCategory === cat.slug ? styles.active : ''}`}
                                        onClick={() => this.onCategoryChange(cat.slug)}
                                    >
                                        {cat.name}
                                    </button>
                                ))}
                            </div>
                        )}

                        {loading ? (
                            <div className={styles.loadingText}>Loading articles...</div>
                        ) : articles.length === 0 && !featuredArticle ? (
                            <div className={styles.emptyText}>No articles found.</div>
                        ) : (
                            <Row className={styles.grid}>
                                {articles.map(article => (
                                    <Col xs={12} md={6} lg={4} key={article.id} className={styles.gridItem}>
                                        <ArticleCard article={article} />
                                    </Col>
                                ))}
                            </Row>
                        )}
                    </Container>
                    <div className={styles.cityScape} />
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateToProps, null)(withRouter(ArticlesHub));
